// extracted by mini-css-extract-plugin
module.exports = {"no-helper-text":"styles_no-helper-text__Uyc2U","noHelperText":"styles_no-helper-text__Uyc2U"};